<template>
  <div class="bg-white w-full">
    <CompEstimateHeader
      :buyerCompanyName="state.estimateData.buyer_company_name"
    ></CompEstimateHeader>
    <router-view
      :estimateData="state.estimateData"
      :validationSchema="state.validationSchema"
      :subtotal="state.subtotal"
      :total="state.total"
      @make-validationschema="makeValidationSchema()"
    ></router-view>
  </div>
</template>

<script>
import { reactive, onMounted, inject } from 'vue';
import { useRouter } from 'vue-router';
import axios from '@/utils/axiosAuth.js';
import rules from '@/utils/validateRules.js';
import CompEstimateHeader from '@/views/estimate/vue/CompEstimateHeader.vue';

export default {
  props: {
    transactionId: {
      type: String,
      required: true,
    },
    patternNumber: {
      type: Number,
      required: true,
    },
  },
  components: {
    CompEstimateHeader,
  },
  setup(props) {
    const globalMethods = inject('globalMethods');
    const router = useRouter();

    const state = reactive({
      estimateData: {},
      subtotal: [],
      total: {},
      validationSchema: {},
    });

    onMounted(() => {
      axios
        .get(
          `transactions/${props.transactionId}/est/init/${props.patternNumber}`
        )
        .then((response) => {
          let data = response.data.data;
          if (data.is_editable === 0) {
            router.push({
              name: 'TransactionSummary',
              params: { id: props.transactionId },
            });
          }

          for (const sectionItem of data.section_items) {
            if (
              !sectionItem.detail_items.length &&
              router.currentRoute.value.meta.isInput
            ) {
              sectionItem.detail_items.push({
                id: null,
                name: sectionItem.name,
                value_id: null,
                quantity: null,
                price: null,
                term: null,
                amount: null,
                est_quantity_unit_id: sectionItem.quantity_units.length
                  ? sectionItem.quantity_units[0].id
                  : null,
                est_term_unit_id: sectionItem.term_units.length
                  ? sectionItem.term_units[0].id
                  : null,
                quantity_unit_name: sectionItem.quantity_units.length
                  ? sectionItem.quantity_units[0].name
                  : null,
                term_unit_name: sectionItem.term_units.length
                  ? sectionItem.term_units[0].name
                  : null,
              });
            }
          }
          Object.assign(state.estimateData, data);
          makeValidationSchema();
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'URLが正しくないか、通信エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
          router.push({
            name: 'TransactionSummary',
            params: { id: props.transactionId },
          });
        });
    });

    function makeValidationSchema() {
      (state.validationSchema.title = (value) => {
        return rules.validate(value, 'required');
      }),
        (state.validationSchema.message = (value) => {
          return rules.validate(value, 'required');
        });
      for (let i = 0; i < state.estimateData.section_items.length; i++) {
        for (
          let s = 0;
          s < state.estimateData.section_items[i].detail_items.length;
          s++
        ) {
          if (
            Object.keys(state.estimateData.section_items[i].detail_items[s])
              .length
          ) {
            state.validationSchema['name' + i + '_' + s] = (value) => {
              return rules.validate(value, 'name');
            };
            state.validationSchema['quantity' + i + '_' + s] = (value) => {
              return rules.validate(value, 'quantity');
            };
            state.validationSchema['price' + i + '_' + s] = (value) => {
              return rules.validate(value, 'price');
            };
          }
        }
      }
      for (const question of state.estimateData.questions) {
        state.validationSchema['question' + question.id] = (value) => {
          return rules.validate(value, 'required');
        };
      }
    }

    return {
      state,
      makeValidationSchema,
    };
  },
};
</script>
